import { useMap, useMapsLibrary } from '@vis.gl/react-google-maps'
import { useEffect, useState } from 'react'

export function useDrawingManager(initialValue: google.maps.drawing.DrawingManager | null = null) {
  const map = useMap()
  const drawing = useMapsLibrary('drawing')

  const [drawingManager, setDrawingManager] = useState<google.maps.drawing.DrawingManager | null>(
    initialValue,
  )

  useEffect(() => {
    if (!map || !drawing) return () => undefined

    const newDrawingManager = new drawing.DrawingManager({
      map,
      drawingMode: null,
      drawingControl: false,
      drawingControlOptions: {
        position: google.maps.ControlPosition.TOP_CENTER,
        drawingModes: [google.maps.drawing.OverlayType.POLYGON],
      },
      polygonOptions: {
        editable: true,
        draggable: false,
        fillColor: '#528DE0',
        fillOpacity: 0.25,
        strokeColor: '#0A57C2',
        strokeWeight: 2,
      },
    })

    setDrawingManager(newDrawingManager)

    return () => {
      newDrawingManager.setMap(null)
    }
  }, [drawing, map])

  return drawingManager
}
